import BasePage from "../../../../base/BasePage";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import { Button, dialog } from "nq-component";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
class ModalContent extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      payrollCode: "",
      percentage: 0,
      startDate: "",
      endDate: "",
      year: "",
      monthFrom: "",
      monthTo: "",
      selectedYear: "",
    };
  }

  _handleInputChange(value, type) {
    this.setState({ [type]: value });
    const handlerMap = {
      payrollCode: this.props.onPayrollCode,
      percentage: this.props.onPercentage,
      startDate: this.props.onStartDate,
      endDate: this.props.onEndDate,
      year: this.props.onSelectYear,
      monthFrom: this.props.onMonthFrom,
      monthTo: this.props.onMonthTo,
      selectedYear: this.props.selectedYear,
    };

    if (handlerMap[type]) {
      handlerMap[type](value);
    }
  }

  _getYearOptions() {
    const startYear = 2015;
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = currentYear; year >= startYear; year--) {
      years.push(year.toString());
    }
    return years;
  }

  _onSelect(key, value) {
    this.setState({ [key]: value });
  }

  //   handleContinue() {
  //     if (!this.state.startDate || !this.state.endDate) {
  //       this.showError("Start date and End date is required!");
  //     } else if (!this.state.year) {
  //       this.showError("Year is required!");
  //     } else {
  //       this.props.onGenerate();
  //     }
  //   }

  render() {
    const { payrollTypes, payItems } = this.props.selectedTypes;

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return (
      <>
        <FloatingForm width="40%">
          <CardView>
            <div className="row p-2">
              <h5 className="text-left mb-3">
                Please input necessary details!
              </h5>

              <div className="mb-2 col-12">
                <label className="form-label ms-2 me-2">Payroll Code</label>
                <div className="ms-2 me-2">
                  <InputFactory
                    type="String"
                    onChange={(value) =>
                      this._handleInputChange(value, "payrollCode")
                    }
                  />
                </div>
              </div>

              {payrollTypes === "AP" && (
                <div className="mb-2 col-12">
                  <label className="form-label ms-2 me-2">
                    Enter Percentage
                  </label>
                  <div className="ms-2 me-2">
                    <InputFactory
                      type="Number"
                      onChange={(value) =>
                        this._handleInputChange(value, "percentage")
                      }
                    />
                  </div>
                </div>
              )}

              <h5 className="text-left mt-2 mb-2">Period Covered</h5>
              {payItems !== "20% Monthly Premium" && (
                <>
                  <div className="col-md-6 ">
                    <label className="form-label ms-2 me-2">Start Date</label>
                    <div className="ms-2 ">
                      <InputFactory
                        type="Date"
                        onChange={(value) =>
                          this._handleInputChange(value, "startDate")
                        }
                        disabled={this.state.year}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <label className="form-label ms-2 me-2">End Date</label>
                    <div className=" me-2">
                      <InputFactory
                        type="Date"
                        onChange={(value) =>
                          this._handleInputChange(value, "endDate")
                        }
                        disabled={this.state.year}
                      />
                    </div>
                  </div>
                </>
              )}
              {payItems === "20% Monthly Premium" && (
                <>
                  {["monthFrom", "monthTo"].map((field) => (
                    <div className="col-md-6" key={field}>
                      <label className="form-label ms-2 me-2">
                        {field === "monthFrom" ? "Month From" : "Month To"}
                      </label>
                      <div className="ms-2">
                        <SearchSelect
                          value={this.state[field]}
                          onChange={(value) =>
                            this._handleInputChange(value, field)
                          }
                          onClickClear={() =>
                            this._handleInputChange("", field)
                          }
                          options={months.map((month) => ({
                            label: month,
                            value: month,
                          }))}
                          disabled={
                            field === "monthTo" && !this.state.monthFrom
                          }
                        />
                      </div>
                    </div>
                  ))}
                  <div className="col-md-12 ">
                    <label className="form-label ms-2 me-2">Select Year</label>
                    <div className=" ms-2 ">
                      <SearchSelect
                        value={this.state.year}
                        onChange={(value) =>
                          this._handleInputChange(value, "selectedYear")
                        }
                        onClickClear={() =>
                          this._handleInputChange("", "selectedYear")
                        }
                        options={this._getYearOptions().map((year) => ({
                          label: year,
                          value: year,
                        }))}
                        disabled={this.state.startDate || this.state.endDate}
                        placeholder="Select Year"
                      />
                    </div>
                  </div>
                </>
              )}
              {payrollTypes === "SP" && payItems !== "20% Monthly Premium" && (
                <>
                  <label className="form-label mt-2 ms-2 me-2">or</label>
                  <div className="col-md-12 ">
                    <label className="form-label ms-2 me-2">Select Year</label>
                    <div className=" ms-2 me-2">
                      <SearchSelect
                        value={this.state.year}
                        onChange={(value) =>
                          this._handleInputChange(value, "year")
                        }
                        onClickClear={() => this._handleInputChange("", "year")}
                        options={this._getYearOptions().map((year) => ({
                          label: year,
                          value: year,
                        }))}
                        disabled={this.state.startDate || this.state.endDate}
                        placeholder="Select Year"
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="w-100 d-flex justify-content-end gap-2 pe-3 pb-3 mt-4">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.onClose()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={() => this.props.onGenerate()}
                >
                  Generate Payroll
                </Button>
              </div>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}

export default ModalContent;
